import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MdbChartDirective } from 'mdb-angular-ui-kit/charts';
import { ComponentBase, ChartData } from 't4core';
import * as moment from 'moment';

@Component({
  selector: 't4-fleet-chart',
  templateUrl: 'fleet-chart.html',
})
export class T4FleetChartWidget extends ComponentBase implements OnInit {

    @ViewChild(MdbChartDirective, {static: false}) diagram: MdbChartDirective;
    @Input() title: string = "";
    @Input() orientation: string = "horizontal";


    @Input() fromDate: moment.Moment = moment().startOf('month');
    @Input() toDate: moment.Moment = moment().endOf('month');
    @Input() diagramIds: string[] = [];
    @Input() unit: string = "week";
  public isLoading: boolean = false;
  private isInitializing: boolean = true;
    constructor() {
        super();
    }

  public async ngOnInit() {
    this.isLoading = true;
    var results = [];
    var totalAmount = 0;
    var relatedTotalAmount = 0;
    var result = await this.Api.get<ChartData>("Data/GetDiagramData", { diagramId: this.diagramIds[0], from: this.fromDate, to: this.toDate });
    this.generateChart(result);
    this.isLoading = false;
    this.isInitializing = false;    
  }

  public async ngOnChanges(changes: SimpleChanges) {
    if (this.isInitializing) return;
    if (changes.fromDate || changes.toDate) {
      this.isLoading = true;
      
      var result = await this.Api.get<ChartData>("Data/GetDiagramData", { diagramId: this.diagramIds[0], from: this.fromDate, to: this.toDate });
      if (this.diagram) {
        this.generateChart(result);
        this.isLoading = false;
      }
    }
  }

  public async generateChart(result: ChartData) {
    var totalAmount = 0;
    var relatedTotalAmount = 0;
    
    this.chartLabels = [];
    for (let l of result.Labels) {
      this.chartLabels.push(l);
    }

    for (let c of result.ChartSeries[0]) {
      totalAmount = totalAmount + c;
    }

    for (let c of result.ChartSeries[1]) {
      relatedTotalAmount = relatedTotalAmount + c;
    }

    var chartData = [];
    for (let c of result.ChartSeries[0]) {
      chartData.push(c);
    }
    var relatedChartData = [];
    for (let c of result.ChartSeries[1]) {
      relatedChartData.push(c);
    }

    var d: any = {
      data: relatedChartData,
      label: await this.Translate.translate("Turbo.Core.Chart." + this.diagramIds[0] + ".Series" + 2) + ' (Total: ' + relatedTotalAmount.toFixed(2) + ')',
      backgroundColor: 'rgba(175,175,175,0.5)',
      borderColor: 'rgba(175,175,175,1)'
    };
    var r: Array<any> = [{
      data: chartData,
      label: await this.Translate.translate("Turbo.Core.Chart." + this.diagramIds[0] + ".Series" + 1) + ' (Total: ' + totalAmount.toFixed(2) + ')',
      backgroundColor: 'rgba(255, 99, 132, 0.2)',
      borderColor: 'rgba(205, 151, 151, 0)'
    }];
    this.chartDatasets = [{}, {}];
    this.chartDatasets = r;
    this.chartDatasets.push(d);

    this.diagram.update();
  } 

    public chartType: string = 'bar';

    public chartDatasets: Array<any> = [{}, {}];

    public chartLabels: Array<any> = [];

    public chartOptions: any = {
      responsive: true,
      indexAxis: 'y',
      scales: {
        y: {
          stacked: false,
          ticks: {
            display: true
          }
        },      
        y1: {
          stacked: false,
          ticks: {
            display: false
          }
        },
        x: {
          position: 'top',
          barPercentage: 1.0,
          categoryPercentage: 0.55
        }
      },
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)'
      ],
      borderColor: [
        'rgba(255,99,132,1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)'
      ],
    };

    public chartClicked(e: any): void {

    }

    public chartHovered(e: any): void {

    }
}
